module.exports = __webpack_public_path__ + "img/system-maintenance.1e43439b.png";